export default __webpack_public_path__ + "static/modal-background-zona-v-f4ffabe92ccde76e9f7f12b39321f381.png";